import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/periods/3/chart.svg")